import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CompareserviceService } from '../compareservice.service';
import { MatTableDataSource } from '@angular/material/table';
import { AlertPopupComponent } from 'src/app/shared/components/alert-popup/alert-popup.component';
import { DataService } from 'src/app/features/dfte-grid-view/config/data.service';
import { NotificationService } from 'src/app/shared/components/notification/notification.service';
import { MatDialog } from '@angular/material/dialog';
import { TaskListPopupComponent } from 'src/app/shared/components/task-list-popup/task-list-popup.component';
import { DconConfigAPI } from 'src/app/features/dfte-grid-view/config/config';
import { InfoPopupComponent } from 'src/app/shared/components/info-popup/info-popup.component';

export interface ExampleTab {
  label: string;
  content: string;
}


@Component({
  selector: 'app-config-compare-home',
  templateUrl: './config-compare-home.component.html',
  styleUrls: ['./config-compare-home.component.scss']
})
export class ConfigCompareHomeComponent implements OnInit {
  batchKey: Object;
  public loader: boolean;
  public createWorkbookData: any = [];
  public compareWorkbookData: any = [];
  public dataValue: [] = [];
  public dateFormat: any;
  dataSourceWorkBook: any = new MatTableDataSource();
  dataSourceCompareWorkBook: any = new MatTableDataSource();
  filterSelectObj = [];
  filterSelectObjForCompare = [];
  public searchNewBtnDisable: boolean = true;
  public workbookNewBtnDisable: boolean = true;
  filteredValue;
  filterValues = {};
  public searchText;
  hideme: number;
  isTrainStopUrl: boolean;
  queryParams: any;
  refresh: boolean = true;
  failedToFetchCompare: boolean = false;
  failedToFetchBatchKeys: boolean = false;
  noCompareCreated: boolean = false;
  noExtractsFound: boolean = false;
  pageIndex = 0;
  size = 5;
  tableData: any;
  p: any = 1;
  public emptyTable: boolean = false;
  taskLevelData: any = [];

  displayedColumns: string[] = ['batch_key', 'compare_status', 'source_instance', 'target_instance', 'creation_date', 'action'];
  compareBtnDisable: boolean = true;

  constructor(private router: Router, public dialog: MatDialog, private celService: CompareserviceService, private _data: DataService,
    private route: ActivatedRoute,
    private http: HttpClient,
    private notification: NotificationService) {
    this.isTrainStopUrl = this.celService.getisTrainStopUrl();
    if (this.isTrainStopUrl) {
      const obj = JSON.parse(sessionStorage.getItem('queryParams'));
      this.queryParams = obj;
    }

    this.filterSelectObjForCompare = [
      {
        name: 'Status',
        columnProp: 'compare_status',
        options: []
      },
      {
        name: 'Source Instance',
        columnProp: 'source_instance',
        options: []
      }, {
        name: 'Target Instance',
        columnProp: 'target_instance',
        options: []
      }
    ];
  }


  ngOnInit(): void {
    const prjid = this._data.projectID;
    if (prjid === null || prjid === undefined) {
      window.location.href = DconConfigAPI.redirectUri;
    } else {
      this.onRefresh();
      // this.getCompareBatchkeys();
      // this.getSelectedBatchTasks();
      this.dataSourceCompareWorkBook.filterPredicate = this.createFilterForCompare();
    }
  }

  getCompareBatchkeys() {
    this.compareWorkbookData.length = 0;
    this.refresh = false;
    this.emptyTable = false;
    this.compareBtnDisable = false;
    this.celService.getCompareBatchkeys().subscribe((res) => {
      this.refresh = true;
      if (res?.Result === "SUCCESS" && res.BatchKey_Details !== undefined) {
        this.searchNewBtnDisable = false;
        this.noCompareCreated = false;
        this.compareWorkbookData = this.getDistinctBatchKeys(res.BatchKey_Details);
        // this.setCompareStatus(res.BatchKey_Details,this.compareWorkbookData);
        this.sortDataForWorkbook();
        this.loader = false;
        this.failedToFetchCompare = false;
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";

        this.dataSourceCompareWorkBook.data = this.compareWorkbookData;
        this.tableData = this.dataSourceCompareWorkBook.data;

        this.filterSelectObjForCompare.filter((o) => {
          o.options = this.getFilterObject(this.compareWorkbookData, o.columnProp);
          o.options.splice(0, 0, "None");
        });

        if (this.compareWorkbookData.length === 0) {
          console.log("");
        } else {
          res.BatchKey_Details.forEach((element) => {
            if (element.compare_status === 'New') {
              this.compareBtnDisable = true;
            }
          });
        }
      }
      else {
        this.failedToFetchCompare = true;

      }
    }, error => {
      this.notification.showError('Something went wrong!');
      this.refresh = true;
      this.failedToFetchCompare = true;
      this.noCompareCreated = true;
      this._data.apiCallInProgress = false;
      document.getElementById("overlay").style.display = "none";
    });
  }

  onRefresh() {
    this.refresh = false;
    this.emptyTable = false;
    this.pageIndex = 0;
    this.size = 5;
    this.p = 1;
    this.filterValues = {};
    this.searchText = undefined;
    this.maskPage();
    this.filterSelectObjForCompare = [
      {
        name: 'Status',
        columnProp: 'compare_status',
        options: []
      },
      {
        name: 'Source Instance',
        columnProp: 'source_instance',
        options: []
      }, {
        name: 'Target Instance',
        columnProp: 'target_instance',
        options: []
      }
    ];
    this.dataSourceCompareWorkBook = new MatTableDataSource();
    this.dataSourceCompareWorkBook.filterPredicate = this.createFilterForCompare();

    this.getCompareBatchkeys();
    this.getSelectedBatchTasks();

  }

  maskPage() {
    this._data.apiCallInProgress = true;
    document.getElementById("overlay").style.display = "block";
  }

  getDistinctBatchKeys(res) {
    const distinctBatchKeys = res
      .reduce((obj, curr) => {
        let success_count = 0;
        const total_count = 1;
        let ErrorModule;
        let success_path = '';
        const success_files = [];
        if (curr.output_file_path && (curr.output_file_path).includes('\\OUT\\')) {
          success_count++;
          success_path = curr.output_file_path;
          success_files.push(curr.output_file_path);
        } else {
          ErrorModule = {
            "application": "Error",
            "fileList": [curr.output_file_path],
            "output_file_path": curr.output_file_path,
            "success_count": 0,
            "total_count": 0
          };
        }
        const currModule = {
          "application": curr.application,
          "fileList": success_files,
          "output_file_path": success_path,
          "success_count": success_count,
          "total_count": total_count
        };
        const item = {
          "batch_key": curr.batch_key,
          "creation_date": curr.creation_date,
          "compare_status": curr.compare_status,
          "source_instance": curr.source_instance,
          "target_instance": curr.target_instance,
          module: []
        };
        if (!obj[curr.batch_key]) {
          obj[curr.batch_key] = item;
          obj[curr.batch_key].module.push(currModule);
          //if error module then push it
          if (ErrorModule) {
            obj[curr.batch_key].module.push(ErrorModule);
          }
        } else {
          //same batch && new module
          if (curr.source_instance) {
            obj[curr.batch_key].source_instance = curr.source_instance;
          }
          if (curr.target_instance) {
            obj[curr.batch_key].target_instance = curr.target_instance;
          }
          if (!obj[curr.batch_key].module

            .find(e => e.application === curr.application)) {
            if (obj[curr.batch_key].module.length &&
              obj[curr.batch_key].module.find(e => e.application === "Error")) {
              obj[curr.batch_key].module.splice(
                obj[curr.batch_key].module
                  .findIndex((e) => e.application === "Error"), 0, currModule);
            } else {
              obj[curr.batch_key].module.push(currModule);
            }
          } else {
            //same batch && same module
            if (curr.source_instance) {
              obj[curr.batch_key].source_instance = curr.source_instance;
            }
            if (curr.target_instance) {
              obj[curr.batch_key].target_instance = curr.target_instance;
            }
            obj[curr.batch_key].module.map(e => {
              if (e.application === curr.application) {

                e.total_count += 1;

                if (curr.output_file_path
                  && (curr.output_file_path).includes('\\OUT\\')) {
                  e.success_count += 1;
                  e.output_file_path = curr.output_file_path;

                  if (!(e.fileList).includes(curr.output_file_path)) {
                    e.fileList.push(curr.output_file_path);
                  }
                }
              }
              return e;
            });
          }

          //same batch push error module if not available
          if (ErrorModule && !obj[curr.batch_key].module
            .find(e => e.application === 'Error')) {
            obj[curr.batch_key].module.push(ErrorModule);
          }
        }
        obj[curr.batch_key].downloadAll = false;
        obj[curr.batch_key].module.map(e => {
          // if(e.success_count > 0 && obj[curr.batch_key].module.length > 1) {
          if(e.success_count > 0 ) {
            if(obj[curr.batch_key].module.length > 1) {
              obj[curr.batch_key].downloadAll = true;
          }
        }
        });
        return obj;
      }, Object.create(null));

    return Object.values(distinctBatchKeys);
  }

  onClickCompareBatchKey(item) {
    const obj = {
      status: item.status,
      data: item
    };
    const instanceValues = {
      sourceInstance: item.source_instance,
      targetInstance: item.target_instance
    };
    this.celService.instanceData = instanceValues;
    this.celService.batchKey = item.batch_key;
    this.celService.options = obj;
    if (item.compare_status === "New") {
      this.celService.getBatchKeyDetailsForCompare(item.batch_key).subscribe(res => {
        this.celService.batchKeyDetails = this.prepareObjSet(res.Batch_Key_Details);
        this.celService.fromTable = true;
        this.router.navigate(['compare'], { relativeTo: this.route });
      }, error => {
        this.notification.showError('Something went wrong!');
      });
    } else {
      this.extractPopUp(item.compare_status);
    }
  }

  extractPopUp(status) {
    const dialogRef = this.dialog.open(InfoPopupComponent, {
      width: "917px",
      height: "220px",
      data: {
        mess: `Batch Key ${this.celService.batchKey} : <b> ${status}</b>`,
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if ((result = "ok")) {
        dialogRef.close();
      }
    });
  }


  compareConfigClick() {
    const dialogRef = this.dialog.open(InfoPopupComponent, {
      width: "917px",
      height: "290px",
      data: {
        type: 'Comparison Type',
        compare: true
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'File') {

        this.getBatchkey(result);
        
      }else if(result === 'Instance'){
        this.celService.compareTypeValue = result;
        this.celService.options = null;
        this.celService.batchKey = null;
        this.celService.fromTable = false;
        this.router.navigate(["select"], { relativeTo: this.route });
      }else{
        this.celService.compareTypeValue = null;
      }      
    });
  }

  onCreate() {
    this.celService.options = null;
    this.celService.batchKey = null;
    this.celService.fromTable = false;
    this.router.navigate(["select"], { relativeTo: this.route });
  }

  prepareObjSet(batchDetails) {
    const data = [];
    batchDetails.forEach(element => {
      const obj = JSON.parse(element.config_details);
      obj['saveStatus'] = false;
      if (obj.linedetail != null && obj.linedetail.length > 0) {
        obj.linedetail.forEach(element => {
          if (element.taskselected === 'Y') {
            obj['saveStatus'] = true;
          }
        });
      }
      data.push(obj);
    });
    return data;
  }




  filterChange(filter, event) {
    this.pageIndex = 0;
    this.size = 5;
    this.p = 1;
    this.filterValues[filter.columnProp] = event.target.value.trim().toLowerCase();
    this.dataSourceCompareWorkBook.filter = JSON.stringify(this.filterValues);
    this.tableData = this.dataSourceCompareWorkBook.filteredData;
  }

  paginate(event: any) {
    this.pageIndex = event;
    this.tableData = this.dataSourceCompareWorkBook.filteredData.slice(event * this.size - this.size, event * this.size);
  }

  getFilterObject(fullObj, key) {
    const uniqChk = [];
    fullObj.filter((obj) => {
      if (!uniqChk.includes(obj[key])) {
        uniqChk.push(obj[key]);
      }
      return obj;
    });
    return uniqChk;
  }



  createFilterForCompare() {
    const filterFunction = function (data, filter): boolean {
      const searchTerms = JSON.parse(filter);
      let isFilterSet = false;
      for (const col in searchTerms) {
        if (searchTerms[col].toString() !== '' && searchTerms[col].toString().toLowerCase() !== 'none') {
          isFilterSet = true;
        } else {
          delete searchTerms[col];
        }
      }

      const nameSearch = () => {
        let found = false;

        if (isFilterSet) {
          if (data.compare_status.toLowerCase() === searchTerms.compare_status && (!searchTerms.source_instance || searchTerms.source_instance === "undefined")) {
            found = true;
          } else if (data.compare_status.toLowerCase() === searchTerms.compare_status && data.source_instance.toLowerCase() === searchTerms.source_instance && (!searchTerms.target_instance || searchTerms.target_instance === "undefined")) {
            found = true;
          } else if (data.compare_status.toLowerCase() === searchTerms.compare_status && data.source_instance.toLowerCase() === searchTerms.source_instance && data.source_instance.toLowerCase() === searchTerms.target_instance) {
            found = true;
          } else if (data.compare_status.toLowerCase() == searchTerms.compare_status && data.target_instance.toLowerCase() === searchTerms.target_instance && (!searchTerms.source_instance || searchTerms.source_instance === "undefined")) {
            found = true;
          } else if ((!searchTerms.compare_status || searchTerms.compare_status === "undefined") && data.target_instance.toLowerCase() === searchTerms.target_instance && (!searchTerms.source_instance || searchTerms.source_instance === "undefined")) {
            found = true;
          } else if ((!searchTerms.compare_status || searchTerms.compare_status === "undefined") && data.source_instance.toLowerCase() === searchTerms.source_instance && (!searchTerms.target_instance || searchTerms.target_instance === "undefined")) {
            found = true;
          } else if ((!searchTerms.compare_status || searchTerms.compare_status === "undefined") && data.source_instance.toLowerCase() === searchTerms.source_instance && data.source_instance.toLowerCase() === searchTerms.source_instance) {
            found = true;
          }
          else if ((!searchTerms.compare_status || searchTerms.compare_status === "undefined") && (!searchTerms.source_instance || searchTerms.source_instance === "undefined") && (!searchTerms.target_instance || searchTerms.target_instance === "undefined")) {
            found = true;
            this.dataSource = data;
          }
          return found;
        }
        else {
          return true;

        }
      };
      return nameSearch();
    };
    return filterFunction;
  }


  getDownloadDropdown(i) {
    this.hideme = i;
  }

  getRefresh() {
    this.ngOnInit();
    this.hideme = null;
  }

  autoCloseForDropdownCars(event) {
    var target = event.target;
    if (!target.closest(".download-enhancement")) {
      this.hideme = null;
    }
  }

  downloadFiles(module, batchKey) {
    let fileList;
    if(Array.isArray(module)) {

      fileList = module.reduce((obj, curr) => {
        // if(curr.application !=='Error' && curr.fileList) {
        if(curr.fileList && curr.fileList.length) {
          obj.push(curr.fileList[0]);
        }
        return obj;
      },[]);
    } else if (module.fileList) {
      fileList = module.fileList;
    }
    if (fileList && fileList.length > 0) {
      this._data.apiCallInProgress = true;
      document.getElementById("overlay").style.display = "block";
      const body = {
        "fileList": fileList
      };

      this.celService.downloadFiles(body).subscribe(res => {
        if (res.byteLength === 1176) {
          this.notification.showError("Failed to download compare file");
        } else {
          this.writeContents(res, `${batchKey}_COMPARE.zip`);
          this._data.apiCallInProgress = false;
          document.getElementById("overlay").style.display = "none";
          this.hideme = null;
        }
      },
        error => {
          this._data.apiCallInProgress = false;
          document.getElementById("overlay").style.display = "none";
          this.notification.showError("Failed to download compare file");
        });
    } else {
      this.notification.showError("File not found");
    }
  }



  writeContents(content, fileName) {  //contentType
    const a = document.createElement('a');
    const file = new Blob([content]); //, { type: contentType }
    a.href = URL.createObjectURL(file);
    a.download = fileName;
    a.click();
  }

  alertPopUp(type, mess) {
    const dialogRef = this.dialog.open(AlertPopupComponent, {
      width: "917px",
      height: "220px",
      data: {
        type: type,
        mess: mess
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if ((result = "ok")) {
        dialogRef.close();
      } 
    });
  }

  search(value: string): void {
    if (value == null || value === undefined) {
      return;
    }
    this.pageIndex = 0;
    this.size = 5;
    this.p = 1;
    const serchText = value.toUpperCase();
    this.dataSourceCompareWorkBook.data = this.compareWorkbookData.filter((val) => val.batch_key.toUpperCase().includes(serchText));
    this.tableData = this.dataSourceCompareWorkBook.filteredData;

    if (this.compareWorkbookData.some(item => item.batch_key === value) || value === "") {
      this.emptyTable = false;
      this.filterValues = {};
      this.searchText = undefined;
      this.filterSelectObjForCompare = [
        {
          name: 'Status',
          columnProp: 'compare_status',
          options: []
        },
        {
          name: 'Source Instance',
          columnProp: 'source_instance',
          options: []
        }, {
          name: 'Target Instance',
          columnProp: 'target_instance',
          options: []
        }
      ];
      this.filterSelectObj.filter((o) => {
        o.options = this.getFilterObject(this.compareWorkbookData, o.columnProp);
        o.options.splice(0, 0, "None");
      });
      this.dataSourceCompareWorkBook = new MatTableDataSource();
      this.dataSourceCompareWorkBook.filterPredicate = this.createFilterForCompare();
      this.dataSourceCompareWorkBook.data = this.compareWorkbookData.filter((val) => val.batch_key.toUpperCase().includes(serchText));
      this.dataSourceCompareWorkBook.filter = JSON.stringify(this.filterValues);
      this.tableData = this.dataSourceCompareWorkBook.filteredData;

    } else {
      this.emptyTable = true;
    }
  }

  sortDataForWorkbook() {
    return this.compareWorkbookData.sort((a, b) => {
      return <any>new Date(b.creation_date) - <any>new Date(a.creation_date);
    });
  }

  searchOnInput(event) {
    if (event == null || event === undefined || event === '') {
      this.search('');
    }
  }

  getSelectedBatchTasks() {
    this.maskPage();
    this.celService.getSelectedBatchTasks().subscribe((res) => {
      if (res?.Result === "SUCCESS" && res.Config_Batchkey_Details !== undefined) {
        this.taskLevelData = this.getDistinctBatchKeysNew(res.Config_Batchkey_Details);//res.Batch_key_details;
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";

      } else {
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";
      }

    }, error => {
      this._data.apiCallInProgress = false;
      document.getElementById("overlay").style.display = "none";
      this.notification.showError('Something went wrong!');
    });
  }

  getDistinctBatchKeysNew(res) {
    const distinctBatchKeys = res.reduce((obj, curr) => {
      const item = {
        "batch_key": curr.batch_key,
        module: []
      };
      const task_list = [curr.task_name];
      const currModule = {
        "application": curr.application,
        "task_list": task_list,
      };
      if (!obj[curr.batch_key]) {
        obj[curr.batch_key] = item;
        obj[curr.batch_key].module.push(currModule);
      } else {
        //same batch && new module
        if (!obj[curr.batch_key].module
          .find(e => e.application === curr.application)) {
          obj[curr.batch_key].module.push(currModule);
        } else {
          //same batch && same module
          obj[curr.batch_key].module.map(e => {
            if (e.application === curr.application) {
              e.task_list.push(curr.task_name);
            }
          });
        }
      }
      return obj;
    }, Object.create(null));
    return Object.values(distinctBatchKeys);
  }


  tasklistPopup(batchkey) {
    const module = this.taskLevelData.filter(e => e.batch_key === batchkey);
    const dialogRef = this.dialog.open(TaskListPopupComponent, {
      width: "795px",
      height: "470px",
      data: {
        moduleData: { batchkey: batchkey, module: module },
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      
    });
  }

  getBatchkey(result){
    const body = {
      batchkey: "",
      projectname: this.celService.projId,
      requestedby: this.celService.requestedBy,
      targetinstance: 'TEST',
      sourceinstance: 'FILE',
      filesharepath: this.celService.getfileSharePath(),
      requesttype: DconConfigAPI.API_VARIABLES.Request_Type_Compare,
      extracttype: DconConfigAPI.API_VARIABLES.Extract_Type_SQL,
      instanceid: '97',
      targetinstanceid: '3',
      LineItems: [],
      comparisonType: 'File'
    };
    this.celService.onConfigSubmit(body).subscribe((res) => {
      this.batchKey = res.Batch_Key;
      this.celService.compareTypeValue = result;
      this.celService.options = null;
      this.celService.batchKey = res.Batch_Key;
      this.celService.fromTable = false;
      this.router.navigate(["compare_file_submit"], { relativeTo: this.route });
    },
      (error) => {
        this.notification.showError('Something went wrong!');
      });
  }

}


